import type { PurchaseOrder } from "@shared/types";

/**
 * Cache utilities for ShippingDocumentsDialog
 */

export interface CachedLabelUrlEntry {
  url: string;
  /**
   * Epoch milliseconds when the URL is expected to expire (best-effort).
   * Undefined when URL is not a pre-signed URL or expiry cannot be parsed.
   */
  expiresAt?: number;
}

/**
 * Creates a cache key from an array of orders
 */
export const createOrdersCacheKey = (orders: PurchaseOrder[]): string => {
  return orders.map((order) => order.purchaseOrderId).join(",");
};

/**
 * Yields cached URLs from a record of cached label URLs
 */
export const yieldCachedUrls = function* (
  orders: PurchaseOrder[],
  cachedUrls: Record<string, CachedLabelUrlEntry>
): Generator<string, void, unknown> {
  for (const order of orders) {
    const entry = cachedUrls[order.purchaseOrderId];
    if (entry?.url) {
      yield entry.url;
    }
  }
};
